import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { sortByColumn } from '../utils/sorters';
import { ContentControlTrafficExclusion } from '@nirvana/shared/dtos/types/policies/common';
import { SetFiltersRequest } from '../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';

export class GzContentControlTrafficExclusionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ContentControlTrafficExclusion
> {
  sortByColumnMethod(
    a: ContentControlTrafficExclusion,
    b: ContentControlTrafficExclusion,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.ENTITY);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.REMARKS);
    return;
  }
}
